module.exports = __webpack_public_path__ + "img/balance.58569a5e.png";